<template lang="pug">
v-app.home-page
  xo-toolbar
  .main-section.mx-auto(style="max-width: 1600px; width: 100%")
    v-row(
      no-gutters,
      :class="$vuetify.breakpoint.smAndDown ? 'cols=12' : 'cols=6'"
    )
      v-col(cols="12", lg="6", md="6", sm="12")
        .main-content.d-flex.justify-center.flex-column
          div(
            :class="$vuetify.breakpoint.smOnly ? 'd-flex flex-inline px-0' : 'd-flex flex-column '"
          )
            .text-content.mx-auto
              p Hi there. My name is Cielo and I'm the founder of <b>JustAsk!</b>. We specialize in providing capable staff with the right skillsets to match your requirements.
              p Our strength is business process optimization through operational efficiencies, quality assurance and business analytics.
              p We offer comprehensive administrative and operations support services that will allow you to have more head space to focus on your main offerings and help you grow your business.
            img.main-image-sm.mr-1.d-none(src="/images/new/home/homesm.jpg")

          v-spacer
          v-btn.cPrimary-btn.mx-auto(@click="goTo('/services')") SEE WHAT WE OFFER
          v-spacer
          .d-flex.justify-center
            img.logo(src="@/assets/images/logoStand.png", width="250")
          .cDivider.pb-5
          .d-flex.justify-center
            .icons.d-flex.justify-space-between(style="width: 200px")
              a(
                href="https://www.facebook.com/justaskphilippines",
                target="_blank",
                style="text-decoration: none"
              ): v-icon(
                color="#007D93",
                size="35"
              ) mdi-facebook
              a(
                href="https://www.instagram.com/justaskph/",
                target="_blank",
                style="text-decoration: none"
              ): v-icon(
                color="#007D93",
                size="35"
              ) mdi-instagram
              a(
                href=" https://www.linkedin.com/company/justask-ph/",
                target="_blank",
                style="text-decoration: none"
              ): v-icon(
                color="#007D93",
                size="35"
              ) mdi-linkedin
              a(
                href="mailto: hello@justask.ph",
                target="_blank",
                style="text-decoration: none"
              ): v-icon(
                color="#007D93",
                size="35"
              ) mdi-email-outline

      v-col.main-image(
        cols="6",
        lg="6",
        md="6",
        sm="12",
        v-show="$vuetify.breakpoint.mdAndUp"
      )
</template>

<script>
export default {
  methods: {
    goTo(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
//large
@media (min-width: 1265px) {
  .home-page {
    .main-image {
      background-image: url("/images/new/home/Home.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: auto;
      min-height: 100vh;
    }
    .main-content {
      height: 100%;
      padding: 50px 170px 50px 100px;
      .text-content {
        margin-top: 100px;
        max-width: 450px;
        font-size: 1.2rem;
        color: #1f9599;
        font-style: italic;
      }
      .cPrimary-btn {
        // margin-top: 20px !important;
        color: white;
        font-weight: medium !important;
        background: #fa9221;
        border-radius: 20px;
        box-shadow: 7px 6px 0px 0px #1f9297;
        max-width: max-content;
        font-size: 1.2rem;
        padding: 20px;
      }
      .logo {
        margin-top: 10px;
        width: 200px;
      }
      .icons {
        // margin-top: -30px;
        .v-icon {
          font-size: 40px;
        }
      }
    }
  }
}
//medium
@media (min-width: 961px) and (max-width: 1264px) {
  .home-page {
    .main-image {
      background-image: url("/images/new/home/Home.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: auto;
      min-height: 100%;
    }
    .main-content {
      height: auto !important;
      padding: 50px 60px !important;
      .text-content {
        margin-top: 70px;
        max-width: 830px;
        font-size: 1.2rem !important;
        color: #1f9599;
        font-style: italic;
      }
      // .cPrimary-btn {
      //     font-size: 1.2rem !important;
      //     padding: 23px 10px !important;
      // }

      .cPrimary-btn {
        margin-top: 20px !important;
        color: white !important;
        font-weight: medium !important;
        background: #fa9221 !important;
        border-radius: 10px !important;
        box-shadow: 4px 3px 0px 0px #1f9297 !important;
        max-width: max-content !important;
        font-size: 1.1rem !important;
        padding: 15px 20px !important;
      }
    }

    .logo {
      width: 200px !important;
    }
    .icons {
      width: 150px !important;
    }
  }
}

//small
@media (max-width: 961px) {
  .home-page {
    .main-content {
      justify-content: center !important;
      flex-direction: column !important;
      padding-top: 100px !important;
      .main-image {
        height: 100px !important;
        width: 230px !important;
        object-fit: cover;
        margin-top: 30px !important;
        border-radius: 20px 0;
      }
      .text-content {
        margin-top: 10px !important;
        max-width: 400px !important;
        font-size: 1rem !important;
        color: #1f9599;
        font-style: italic;
      }
      .cPrimary-btn {
        margin-top: 30px !important;
        font-size: 1rem !important;
        padding: 15px 20px !important;
      }
      .logo {
        width: 150px !important;
      }
      .main-image-sm {
        background-image: url("/images/new/home/homesm.jpg");
        background-position: center;
        margin-top: 30px;
        max-height: 300px !important;
        display: block !important;
        object-fit: cover;
        width: 100%;
      }
    }
  }
}
//xs
@media (min-width: 320px) and(max-width: 599px) {
  .main-content {
    justify-content: center !important;
    text-align: center;
    padding: 100px 30px 0px 30px !important;
    .text-content {
      margin-top: 10px !important;
      max-width: 500px !important;
      padding: 0 !important;
      font-size: 1.1rem !important;
      color: #1f9599;
      font-style: italic;
    }
    .cPrimary-btn {
      color: white !important;
      font-weight: medo !important;
      background: #fa9221 !important;
      border-radius: 10px !important;
      box-shadow: 7px 6px 0px 0px #1f9297 !important;
      max-width: max-content !important;
      font-size: 1rem !important;
      padding: 15px 20px !important;
    }
    .logo {
      margin-top: 10px !important;
      width: 200px !important;
    }

    .main-image-sm {
      background-image: url("/images/new/home/Home.jpg");
      background-position: center;
      max-height: 188px !important;
    }
  }
}
</style>
